export default {
    key: "municipal_works",
    folder: "municipalWorks",
    basePath: "mworks",
};